import SpeciesLabel from "../../shapes/labels/SpeciesLabel";
import { onCanvas } from "../../shared/mouseFunctions";
import AbstractTool from "../AbstractTool";
import SelectionMenu from "../SelectionMenu";
import { ADD_SPECIES_TO_ELEMENT } from "../actions/ActionHelper";

export default class AddSpeciesTool extends AbstractTool {
    resetPreviousTool = true;
    menu = new SelectionMenu(this.provider, 'edit');

    activate(species, sticky = false) {
        this.passArgs(species, sticky);
    }

    deactivate() {
        this.menu.remove();
        this.species = null;
        this.img.remove();
        this.img = null;
        this.hoverSet.reset();
    }

    passArgs(species, sticky = false) {
        this.sticky = sticky;
        this.species = species;
        this.img = this.p.createImg(this.species.thumb)
            .size(40, 40)
            .style('border-radius', '20px')
            .position(this.p.mouseX, this.p.mouseY)
            .style('position', 'absolute')
            .style('z-index', '1000')
            .style('opacity', '0.6');
    }

    display() {
        if (onCanvas(this.provider)) {
            this.img.show();
        } else {
            this.img.hide();
        }
    }

    dragMouse(event) { }

    pressMouseOnCanvas() {
        if (this.p.mouseButton === this.p.RIGHT) {
            let hovered = this.elements.hoveredAll();
            if (hovered.length > 1) {
                this.menu.refresh(hovered, this.species);
                return;
            }
        }
    }

    releaseMouseOnCanvas() { }

    clickMouseOnCanvas() {
        if (this.menu.initialized) {
            this.menu.remove();
            return;
        }
        let hovered = this.elements.hovered();
        if (hovered) {
            this.actions.execute(ADD_SPECIES_TO_ELEMENT, hovered, this.species);
            if (!this.sticky && !this.p.keyIsDown(this.p.SHIFT)) {
                this.tools.setTool('select');
                this.sideBar.setTab('info');
                this.selection.select(hovered);
            }
        }
    }

    doubleClickedOnCanvas() { }

    moveMouse() {
        this.cursor.cross();
        this.img.position(this.p.mouseX, this.p.mouseY);
        if (!this.menu.initialized) {
            this.hoverSet.set(this.elements.hovered());
        }
    }

    getTips() {
        return 'Click on an element to add ' + this.species.name + ' to it. Hold SHIFT to add to multiple elements. Right click to select element when they overlap.';
    }

    pressKey(code) {
        switch (code) {
            case 27: // Esc
                if (this.menu.initialized) {
                    this.menu.remove();
                    return;
                }
                this.setTool('select');
                break;
        }
    }

    pressKeyWithControl(code) { }

    pressKeyWithShift(code) { }

    pressKeyHotKeysDisabled(code) { }

    makeSticky(inputField) { }
}
